module.exports = __webpack_public_path__ + "img/examination-pic4.25096666.png";